import { Link, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function TabButtonUnderCreateTab() {
  const location = useLocation();
  const { t } = useTranslation();

  const tabs = [
    { title: t("category"), path: "category-table" },
    { title: t("subCategory"), path: "sug-category-table" },
    { title: t("items"), path: "items" },
    // { title: t("ledgers"), path: "new-ladger" },
  ];

  return (
    <div>
      <header className="tabs-header  flex gap-3 px-2">
        {tabs.map((tab) => {
      const fullPath = `/inventory-books/category/${tab.path}`;

      const isActive =
        (location.pathname === "/inventory-books/category" && tab.path === "category-table") ||
        location.pathname === fullPath;

          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`tab no-underline rounded-1 h-7 mt-[3px] pt-[3px] text-sm  px-2  ${isActive
                 ? `bg-theme-headerBg text-theme-color font-medium border-1 border-theme-headerBg`
                  : `text-theme-tabColor border-1  border-black hover:!border-theme-headerBg  hover:!text-theme-headerBg `
                  }`}
            >
              {tab.title}
            </Link>
          );
        })}
      </header>

      <main className="tab-content">
        <Outlet />
      </main>
    </div>
  );
}

